var _path, _rect, _path2, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryStyleSlider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.1935C15 18.7288 15.3202 18.3253 15.7728 18.2197L19.7728 17.2864C20.4 17.14 21 17.6161 21 18.2602V29.7398C21 30.3839 20.4 30.86 19.7728 30.7136L15.7728 29.7803C15.3202 29.6747 15 29.2712 15 28.8065V19.1935Z",
    fill: "#B4B4B4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 14,
    width: 14,
    height: 20,
    rx: 1,
    fill: "#B4B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28.8065C45 29.2712 44.6798 29.6747 44.2272 29.7803L40.2272 30.7136C39.6 30.86 39 30.3839 39 29.7398L39 18.2602C39 17.6161 39.6 17.14 40.2272 17.2864L44.2272 18.2197C44.6798 18.3253 45 18.7288 45 19.1935L45 28.8065Z",
    fill: "#B4B4B4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 47,
    rx: 1.5,
    stroke: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryStyleSlider);
export default __webpack_public_path__ + "static/media/gallery-style-slider.dd2da770c4535afaf0fd395803a01c08.svg";
export { ForwardRef as ReactComponent };